function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M0.534147344,21.5875714 C-0.0660049477,20.9823026 -0.0663838135,20.0013503 0.534143481,19.3957034 L19.2730026,0.497091721 C19.8731528,-0.108174836 20.8460582,-0.108306174 21.4463425,0.497095616 L21.4463425,0.497095616 C22.0464948,1.10236432 22.0468736,2.0833167 21.4463463,2.68896361 L2.70748718,21.5875752 C2.10733703,22.1928418 1.13443159,22.1929731 0.534147344,21.5875714",
  id: "path-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.4463425,21.5875714 C20.8461902,22.1928401 19.8735299,22.1932222 19.2730026,21.5875752 L0.534143481,2.68896361 C-0.066006677,2.08369705 -0.0661369047,1.10249741 0.534147344,0.497095616 L0.534147344,0.497095616 C1.13429964,-0.108173092 2.10695989,-0.108555188 2.70748718,0.497091721 L21.4463463,19.3957034 C22.0464965,20.0009699 22.0466267,20.9821696 21.4463425,21.5875714",
  id: "path-2"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-2",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Artboard",
  transform: "translate(-1.000000, -1.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(1.000000, 1.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rectangle-2"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#FFFFFF",
  fillRule: "evenodd",
  xlinkHref: "#path-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.534147344,21.5875714 C1.13438602,22.1929272 2.10729145,22.1928878 2.70748718,21.5875752 L21.4463463,2.68896361 C22.0467434,2.08344806 22.0466251,1.10249572 21.4463425,0.497095616 C20.8461038,-0.108260211 19.8731984,-0.108220803 19.2730026,0.497091721 L0.534143481,19.3957034 C-0.0662535612,20.0012189 -0.0661352317,20.9821712 0.534147344,21.5875714 Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle-2"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#FFFFFF",
  fillRule: "evenodd",
  xlinkHref: "#path-2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.4463425,21.5875714 C20.8460599,22.1929715 19.8733997,22.1930908 19.2730026,21.5875752 L0.534143481,2.68896361 C-0.0660522548,2.08365109 -0.0660913305,1.10245144 0.534147344,0.497095616 C1.13442992,-0.108304487 2.10709014,-0.108423825 2.70748718,0.497091721 L21.4463463,19.3957034 C22.0465421,20.0010159 22.0465812,20.9822155 21.4463425,21.5875714 Z M21.4463425,21.5875714 C22.0465812,20.9822155 22.0465421,20.0010159 21.4463463,19.3957034 L2.70748718,0.497091721 C2.10709014,-0.108423825 1.13442992,-0.108304487 0.534147344,0.497095616 C-0.0660913305,1.10245144 -0.0660522548,2.08365109 0.534143481,2.68896361 L19.2730026,21.5875752 C19.8733997,22.1930908 20.8460599,22.1929715 21.4463425,21.5875714 Z"
})))));

var SvgX = function SvgX(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "23px",
    viewBox: "0 0 22 23",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgX, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/x.9de3d925.svg";
export { ForwardRef as ReactComponent };